module.exports = __webpack_public_path__ + "static/media/criminal_traffic.c28fb24c.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdfs/criminal_traffic.pdf
// module id = 2166
// module chunks = 0